import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { AppPath } from '../utils/constants/paths';

/**
 * Superadmin-only pages (Monitor Job). The menu already hides them; this also stops a typed URL,
 * because the API answers other roles with 403 and the interceptor logs out on any 403.
 */
@Injectable({
  providedIn: 'root',
})
export class SuperadminGuard implements CanActivate {
  constructor(private ngRouter: Router, private svAuth: AuthenticationService) {}

  canActivate(): boolean | UrlTree {
    if (this.svAuth.getUser?.Role?.some((role) => role === 'Superadmin')) {
      return true;
    }
    return this.ngRouter.createUrlTree(['', AppPath.dashboard]);
  }
}
